import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useState } from 'react';
import { createProducts, updateProducts } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { Products } from './ProductsColumns';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';


const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showUpdateProductsDrawer: boolean;
    setShowUpdateProductsDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    products: Products
    getProducts: any,
    setProductData: React.Dispatch<React.SetStateAction<Products | undefined>>;
}
const ProductUpdateDrawer: React.FC<ProductsDrawerProps> = ({ showUpdateProductsDrawer, setShowUpdateProductsDrawer, products, getProducts, setProductData }) => {
    const onCLose = () => {
        setShowUpdateProductsDrawer(false)
        setProductData(undefined)
    }
    const [submitting, setSubmitting] = useState(false)
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()


    const onFinish = (products: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.put(`/api/v1/products/${products.id}`, products, {
            signal: controller.signal
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "product successfully updated",
                    `${products.name} was updated`,
                    'topRight'
                )
            }
            getProducts()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }


    return <Drawer
        title="Update Product"
        width={720}
        onClose={onCLose}
        visible={showUpdateProductsDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        style={{ backgroundColor: 'white' }}
        footer={
            <div
                style={{
                    textAlign: 'right',
                }}
            >
                <Button onClick={onCLose} style={{ marginRight: 8 }}>
                    Cancel
                </Button>
            </div>
        }
    >
        <Form layout="vertical"
            onFinishFailed={onFinishFailed}
            onFinish={onFinish}
            initialValues={products}
            form={form}
            hideRequiredMark>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        name="name"
                        label="name"
                        rules={[{ required: true, message: 'Please enter name' }]}
                    >
                        <Input
                            placeholder="Please enter name"
                            className='focus:border-green-500 hover:border-green-500'
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="description"
                        label="Description"
                        rules={[{ required: true, message: 'Please enter description ' }]}
                    >
                        <Input
                            placeholder="Please enter description"
                            className='focus:border-green-500 hover:border-green-500'
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        name="id"
                        label="id"
                        hidden={true}
                        rules={[{ required: true, message: 'Please enter loan id' }]}
                    >
                        <Input placeholder="Please enter loan id" className='focus:border-green-500 hover:border-green-500' />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="status"
                        label="status"
                        hidden={true}
                        rules={[{ required: true, message: 'Please enter loan id' }]}
                    >
                        <Input placeholder="Please enter loan id" className='focus:border-green-500 hover:border-green-500' />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                            Submit
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                {submitting && <Spin indicator={antIcon} />}
            </Row>
        </Form>
    </Drawer>
}

export default ProductUpdateDrawer;


